import { useEffect, useState } from 'react';
import { ExperimentSpec } from '../../constants/ExperimentSpec';
import { noop } from 'ramda-adjunct';
import { useExperiments } from '@wix/wix-experiments-react';

export const useIsOnline = () => {
  const [isOnline, setOnline] = useState<boolean>(true);
  const { experiments } = useExperiments();

  const updateNetworkStatus = () => {
    setOnline(navigator.onLine);
  };

  useEffect(() => {
    if (!experiments.enabled(ExperimentSpec.TrackOffline)) {
      return noop;
    }
    window.addEventListener('online', updateNetworkStatus);
    window.addEventListener('offline', updateNetworkStatus);

    return () => {
      window.removeEventListener('online', updateNetworkStatus);
      window.removeEventListener('offline', updateNetworkStatus);
    };
  }, [experiments]);

  return { isOnline };
};
